import axios from '@/shared/plugins/Axios'

function Requests () {
  async function top9CategoryRequest() {
    try {
      const { data } = await axios.get('/category/top-9-categories')
      return data
    } catch (error) {
      return error.response.data
    }
  }

  async function featuredFreelancerRequest() {
    try {
      const { data } = await axios.get('/featured')
      return data
    } catch (error) {
      return error.response.data
    }
  }

  async function featuredCategoryFreelancerRequest(category_id,currentPage) {
    try {
      const { data } = await axios.get(`/featured/category/${category_id}?page=${currentPage}`)
      return data
    } catch (error) {
      return error.response.data
    }
  }

  async function allFreelancerRequest(pageNumber) {
    try {
      const { data } = await axios.get(`/all/freelancers?page=${pageNumber}`)
      return data
    } catch (error) {
      return error.response.data
    }
  }

  return {
    top9CategoryRequest,
    featuredFreelancerRequest,
    featuredCategoryFreelancerRequest,
    allFreelancerRequest
  }
}

export default Requests()